import { BaseOrganizationEndpoints } from "./base";

/** A pending request from an MCP client (Claude, ChatGPT...) to connect to the user's account */
export type McpAuthorizationRequest = {
  id: string;
  client_name: string;
  client_id: string;
  /** Host the browser is sent back to after answering */
  redirect_host: string;
  /** True when the client only redirects to the user's own machine (e.g. Claude Code) */
  is_loopback: boolean;
  scopes: string[];
  expires: string;
};

export type McpAuthorizationAnswer = {
  /** Where to send the browser back to the client */
  redirect_url: string;
};

/** An MCP client the user connected to their account */
export type McpConnection = {
  id: string;
  client_name: string;
  created: string;
  last_used: string | null;
};

export type McpConnectionListResponse = {
  data: McpConnection[];
};

const BASE_PATH = "/v1/mcp";

export class McpClient extends BaseOrganizationEndpoints {
  async getAuthorization(id: string) {
    return this.requestWithStatus<McpAuthorizationRequest>(
      "GET",
      `${BASE_PATH}/authorizations/${encodeURIComponent(id)}`
    );
  }

  async approveAuthorization(id: string) {
    return this.requestWithStatus<McpAuthorizationAnswer>(
      "POST",
      `${BASE_PATH}/authorizations/${encodeURIComponent(id)}/approve`
    );
  }

  async denyAuthorization(id: string) {
    return this.requestWithStatus<McpAuthorizationAnswer>(
      "POST",
      `${BASE_PATH}/authorizations/${encodeURIComponent(id)}/deny`
    );
  }

  async listConnections() {
    return this.requestWithStatus<McpConnectionListResponse>(
      "GET",
      `${BASE_PATH}/connections`
    );
  }

  async revokeConnection(id: string) {
    return this.requestWithStatus<null>(
      "DELETE",
      `${BASE_PATH}/connections/${encodeURIComponent(id)}`
    );
  }
}
